import { API_URL, fetchWithHandling } from './api';

/** Read-only Gantt overview of client + operational deliverables. */

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export const listDeliverables = async (
  token,
  {
    serviceLineId = null,
    activityId = null,
    readinessStatus = null,
    deliverableCategory = null,
    limit = 200,
  } = {},
) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (serviceLineId) params.set('service_line_id', serviceLineId);
    if (activityId) params.set('activity_id', activityId);
    if (readinessStatus) params.set('readiness_status', readinessStatus);
    if (deliverableCategory)
      params.set('deliverable_category', deliverableCategory);
    const res = await fetchWithHandling(
      `${API_URL}/api/deliverables?${params}`,
      {
        method: 'GET',
        headers: authHeaders(token),
      },
    );
    return { deliverables: res?.deliverables || [] };
  } catch (_err) {
    // API unavailable
    return { deliverables: [] };
  }
};

export const getDeliverable = async (token, deliverableId) => {
  try {
    const res = await fetchWithHandling(
      `${API_URL}/api/deliverables/${deliverableId}`,
      {
        method: 'GET',
        headers: authHeaders(token),
      },
    );
    return {
      deliverable: res?.deliverable || null,
      scope: res?.scope || { in_scope: [], out_of_scope: [] },
      prerequisite_checks: res?.prerequisite_checks || [],
      concerns: res?.concerns || [],
    };
  } catch (_err) {
    // Detail unavailable
    return {
      deliverable: null,
      scope: { in_scope: [], out_of_scope: [] },
      prerequisite_checks: [],
      concerns: [],
    };
  }
};
